import { useCallback, useRef } from 'react';

import {
    exitFullscreen,
    isFullscreenActive,
    requestFullscreen,
} from '@/scenarios/legacy-player/components/PlayerSkin/parts/Layout/utils/fullscreen';

export const useFullscreenRef = (ref: (element: HTMLDivElement | null | undefined) => void) => {
    const widePlayerContainerRef = useRef<HTMLDivElement | null>(null);

    const toggleFullscreen = useCallback(() => {
        if (isFullscreenActive()) {
            exitFullscreen();
        } else if (widePlayerContainerRef.current) {
            requestFullscreen(widePlayerContainerRef.current);
        }
    }, [widePlayerContainerRef]);

    const fullscreenRef = useCallback(
        (element: HTMLDivElement | undefined | null) => {
            if (element) {
                widePlayerContainerRef.current = element;
                ref(element);
            }
        },
        [ref]
    );

    return { toggleFullscreen, fullscreenRef };
};
